import { resetWidget } from "@/CommonDP/VForm/utils";
export const SWITCH_ENUM = {
  num: [0, 1],
  tf: ['F', 'T'],
  yn: ['N', 'Y'],
  bool: [false, true]
};
export function resetSwitch() {
  resetWidget('switch', (schema) => {
    schema.options.activeValue = 'bool';
    schema.component = require('./index.vue').default;
    schema.props = function () {
      return { activeValue() { return import('./setting.vue'); } };
    };
    return schema;
  });
}
